import { call, all, put, takeLatest } from 'redux-saga/effects';

import history from '../../../services/history';
import notification from '../../../services/notification';
import rewardsService from '../../../services/modules/rewards/rewards-service';
import { ISA_ERROR } from '../../../constants';
import { GET_ALL_REQUEST, GET_BY_ID_REQUEST, SAVE_REQUEST, EDIT_ITEM, DELETE_ITEM } from './rewards-constants';
import * as rewardsActions from './rewards-actions';
import { formatMessage } from '~/i18n/translate';

const INITIAL_VALUES = {
  pictureURL: '',
  description: '',
  label: '',
  price: '',
  quantity: '',
  requiredPoints: '',
  type: 'vendor'
};

export function* getAll() {
  try {
    yield put(rewardsActions.setLoadingData(true));

    const { data } = yield call(rewardsService.getAllRewards);
    if (data) {
      yield put(rewardsActions.getAllSuccess([...data]));
    }

    yield put(rewardsActions.setLoadingData(false));
  } catch (error) {
    yield put(rewardsActions.setLoadingData(false));
    yield put({ type: ISA_ERROR, error });
  }
}

export function* getById({ id }: any) {
  try {
    yield put(rewardsActions.setLoadingData(true));

    if (!id) {
      yield put(
        rewardsActions.getByIdSuccess({
          data: INITIAL_VALUES
        })
      );
    } else {
      const { data } = yield call(rewardsService.getReward, id);
      if (data) {
        yield put(
          rewardsActions.getByIdSuccess({
            data
          })
        );
      }
    }
    yield put(rewardsActions.setLoadingData(false));
  } catch (error) {
    yield put(rewardsActions.setLoadingData(false));
    yield put({ type: ISA_ERROR, error });
  }
}

export function* save(data: any) {
  try {
    const { id, payload, files } = data;
    yield put(rewardsActions.setLoadingSend(true));

    const reward = { ...payload };

    if (id) {
      yield call(rewardsService.editReward, { _id: id, ...reward }, files);
    } else {
      yield call(rewardsService.createReward, reward, files);
    }
    yield call(history.push, `/engine/rewards/`, {
      date: new Date().getTime()
    });
    yield put(rewardsActions.setLoadingSend(false));
    yield call(
      notification.success,
      id ? formatMessage('rewardsFormUpdatedSuccess') : formatMessage('rewardsFormCreatedSuccess')
    );
  } catch (error) {
    yield put(rewardsActions.setLoadingSend(false));
    yield put({ type: ISA_ERROR, error });
  }
}

export function* deleteItem({ id }: any) {
  try {
    const { isConfirmed } = yield call(
      notification.confirm,
      formatMessage('commonLabelExclude'),
      formatMessage('commonLabelExcludeItem')
    );
    if (isConfirmed) {
      yield put(rewardsActions.setLoadingSend(true));
      yield call(rewardsService.deleteReward, id);
      yield put(rewardsActions.setLoadingSend(false));

      yield put(rewardsActions.getAllRequest());
      yield call(notification.success, formatMessage('rewardsFormExcludeSuccess'));
    }
  } catch (error) {
    yield put(rewardsActions.setLoadingSend(false));
    yield put({ type: ISA_ERROR, error });
  }
}

export function* editItem({ id }: any) {
  yield call(history.push, `/engine/rewards/edit/${id}`);
}

export default all([
  takeLatest(GET_ALL_REQUEST, getAll),
  takeLatest(GET_BY_ID_REQUEST, getById),
  takeLatest(SAVE_REQUEST, save),
  takeLatest(DELETE_ITEM, deleteItem),
  takeLatest(EDIT_ITEM, editItem)
]);
